module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_promo", [["header",{"id":"promo-header","class":"promo-header"},[["div",{"class":"header-container"},[["div",{"id":"notification-container"}],["div",{"class":"mc-through-notifications-container"}]]]]],["div",{"id":"sitepage-container","class":"sitepage-container"}],["footer",{"id":"promo-footer","class":"promo-footer"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/promo.tpl
// module id = 184
// module chunks = 5